import React, { Component } from "react";
import axios from "axios";
import pds from "../../helpers/pds";
import paounits from "../../helpers/paounits";

class WarrantNoForm extends Component {
  constructor() {
    super();
    this.state = {
      RowKey: "noRowKey",
      isSealed: false,
      approvingDPA: "",
      detectiveName: "",
      agency: "",
      paoUnit: "",
      caseNumber: "",
      inputValidation: "",
      blankValidation: false,
      newWarrantNo: "",
      submitDisabled: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  handleResetForm() {
    this.setState({
      newWarrantNo: ""
    });
  }
  handleSubmit(event) {
    event.preventDefault();
    let flagged = "";
    let blank = false;
    const specials = /[*|\":<>[\]{}`\\();&$#!]/;
    for (let stateObject in this.state) {
      if (
        stateObject !== "inputValidation" &&
        stateObject !== "blankValidation" &&
        stateObject !== "newWarrantNo" &&
        stateObject !== "submitDisabled" &&
        specials.test(this.state[stateObject])
      ) {
        flagged += this.state[stateObject] + " ";
      }
      //this was written this way because they kept changing their mind
      if (
        stateObject !== "inputValidation" &&
        stateObject !== "blankValidation" &&
        stateObject !== "newWarrantNo" &&
        stateObject !== "submitDisabled" &&
        stateObject !== "paoUnit" &&
        stateObject !== "caseNumber" &&
        this.state[stateObject].length === 0
      ) {
        if (stateObject !== "approvingDPA" || this.state.isSealed === true) {
          blank = true;
        }
      }
    }
    if (!!blank) {
      this.setState({
        newWarrantNo: "",
        blankValidation: true,
        inputValidation: ""
      });
    } else if (!!flagged) {
      this.setState({
        newWarrantNo: "",
        blankValidation: false,
        inputValidation: flagged
      });
    } else {
      this.setState({ submitDisabled: true });
      axios.post("/newNumber", this.state).then(response => {
        this.setState({
          newWarrantNo: response.data.message._,
          inputValidation: "",
          blankValidation: false,
          submitDisabled: false,
          isSealed: false,
          approvingDPA: "",
          detectiveName: "",
          agency: "",
          paoUnit: "",
          caseNumber: ""
        });
      });
    }
  }
  render() {
    const pdList = [];
    const paoUnitList = [];
    pdList.push(<option hidden disabled key={"pdOptionNull"} value={""}> -- select an option -- </option>);
    paoUnitList.push(<option hidden disabled key={"paoUnitOptionNull"} value={""}> -- select an option -- </option>);
    pds.forEach((pd, index) => {
      pdList.push(
        <option key={"pdOption" + index} value={pd}>
          {pd}
        </option>
      );
    });
    paounits.forEach((unit, index) => {
      paoUnitList.push(
        <option key={"paoUnitOption" + index} value={unit}>
          {unit}
        </option>
      );
    });
    const newWarrantNo =
      this.state.newWarrantNo === "" ? (
        ""
      ) : (
          <div className="warrantNoForm__newContainer">
            <div className="warrantNoForm__new">
              <span>Your new King County Superior Court Search Warrant number is: <b>{this.state.newWarrantNo}</b></span>
            </div>
            <div className="warrantNoForm__reset">
              <span>Write down or copy your new search warrant number so you can include it in your documents; it will NOT auto fill into the templates.</span><br />
              <span>Note: All your search warrant numbers including your current one can be seen by clicking the “My Numbers” tab above.</span>
              <div className="warrantNoForm__reset--center">
                <span>For another Superior Court Felony Search Warrant Number, click the button below:</span><br />
                <button type="button" onClick={this.handleResetForm}>Get another number</button>
              </div>
            </div>
          </div>
        );
    const inputValidation =
      this.state.inputValidation === "" ? (
        ""
      ) : (
          <div className="warrantNoForm__error">
            Only these special characters are allowed: <b>@ , - ' _</b>
            <br />
            These inputs are invalid: <b>{this.state.inputValidation}</b>
          </div>
        );
    const blankValidation =
      this.state.blankValidation === false ? (
        ""
      ) : (
          <div className="warrantNoForm__error">
            All required fields must be filled before being submitted.
        </div>
        );
    const newNumberForm =
      this.state.newWarrantNo === "" ? (
        <div className="warrantNoForm__formContainer">
          <div className="warrantNoForm__formInfo">
            <ul>
              <li>
                If you require a District Court Search Warrant Number, please contact the District Court Clerk's Office.
          </li>
              <br />
              <li>
                These numbers are not to be used for electronic surveillance applications. Instead, please contact the Spec Ops paralegal.
          </li>
              <br />
              <li>
                Each application must have its own search warrant number. A single application can be used to obtain multiple warrants. For additional warrants and inventories, click on the document “Extra Warrant and Inventory” in the “Search Warrant Templates” tab. Please designate each warrant by individual letter suffix, e.g. XX-0-XXXXX-X<b>A</b>, XX-0-XXXXX-X<b>B</b>, XX-0-XXXXX-X<b>C</b>, etc.
          </li>
            </ul>
          </div>
          <form className="warrantNoForm__form" onSubmit={this.handleSubmit}>
            <div className="warrantNoForm__labels">
              <label className="warrantNoForm__label" htmlFor="detectiveName">
                *Detective's Full Name
        </label>
              <br />
              <label className="warrantNoForm__label" htmlFor="caseNumber">
                Agency Case Number
        </label>
              <br />
              <label className="warrantNoForm__label" htmlFor="agency">
                *Agency
        </label>
              <br />
              <label
                className="warrantNoForm__label"
                htmlFor="approvingDPA"
              >
                <span hidden={!this.state.isSealed}>*</span>DPA Name
        </label>
              <br />
              <label className="warrantNoForm__label" htmlFor="paoUnit">
                PAO Unit
        </label>
              <br />
              <label className="warrantNoForm__label" htmlFor="isSealed">
                Sealed?
        </label>
              <br />
            </div>
            <div className="warrantNoForm__inputs">
              <input
                type="text"
                name="detectiveName"
                className="warrantNoForm__inputs--text"
                value={this.state.detectiveName}
                onChange={this.handleInputChange}
              />
              <br />
              <input
                type="text"
                name="caseNumber"
                className="warrantNoForm__inputs--text"
                onChange={this.handleInputChange}
                value={this.state.caseNumber}
              />
              <br />
              <select
                name="agency"
                onChange={this.handleInputChange}
                value={this.state.agency}
              >
                {pdList}
              </select>
              <br />
              <input
                type="text"
                name="approvingDPA"
                className="warrantNoForm__inputs--text"
                onChange={this.handleInputChange}
                value={this.state.approvingDPA}
              />
              <br />
              <select
                name="paoUnit"
                onChange={this.handleInputChange}
                value={this.state.paoUnit}
              >
                {paoUnitList}
              </select>
              <br />
              <input
                type="checkbox"
                name="isSealed"
                checked={this.state.isSealed}
                onChange={this.handleInputChange}
              />
              <span hidden={!this.state.isSealed}>All sealed search warrants must have an approving DPA.</span>
              <br />
              <input
                type="submit"
                value="Submit"
                className="warrantNoForm__submit"
                disabled={this.state.submitDisabled}
              />
              <span>*Required fields</span>
            </div>
          </form>
        </div>
      ) : (
          ""
        );
    return (
      <div className="warrantNoForm">
        <div className="warrantNoForm__header">
          <span className="warrantNoForm__title">
            Generate a King County Superior Court <b>FELONY</b> Search Warrant Number
              </span>
        </div>
        {newWarrantNo}
        {inputValidation}
        {blankValidation}
        {newNumberForm}
      </div>
    );
  }
}

export default WarrantNoForm;